
import { ACTIONS } from '_redux/actions';
import { get } from './api';

export function fetchEvents(params) {
  return get('event-locations',
    params,
    ACTIONS.EVENTS.FETCH_EVENTS,
    ACTIONS.EVENTS.FETCH_EVENTS_SUCCESS,
    ACTIONS.EVENTS.FETCH_EVENTS_ERROR);
}
